import React, { useState, useEffect } from 'react';
import SideMenuBar from '../../components/sideMenuBar';
import { useNavigate } from 'react-router-dom';
import { ACTIONS, KEYS, URLS } from '../../_config';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import Icon from '../../components/icons';
import Filter from '../../components/filter';
import { useStoreApi } from '../../store/api/hooks/storeApiHook';
import toast from 'react-hot-toast';
import Spinner from '../../components/iconSvgs/spinner';
import { allowOnlyNumbers } from '../../_common/functions';
import { ActivetabProps } from '../../_config/interfaces/interfaces';
import { useStoreSelector, useStoreBrnDSSelector, useAuthStatus } from '../../store/selectors/userSelector';


const BranchInformation: React.FC<ActivetabProps> = ({ activeTab }) => {
    const [isDivVisible, setIsDivVisible] = useState(false);
    const [isDivUpdateVisible, setIsDivUpdateVisible] = useState(false);
    const [visibleUpdateBrnIndex, setVisibleUpdateBnIndex] = useState(-1);
    const [isOnSubmitLoading, setOnSubmitLoading] = React.useState<boolean>(false);
    const [branches, setBranches] = useState<any[]>([]);
    const [filterValue, setFilterValue] = useState<any>({});
    
    const navigate = useNavigate();
    const store = useStoreSelector();
    const isAuth = useAuthStatus();
    const storeAPI: any = useStoreApi();
    const dispatch = useDispatch();
    const branchDS = useStoreBrnDSSelector();
    
    const { register, formState: { errors }, handleSubmit } = useForm<any>();
    const { register: updateRegister, formState: { errors: errorsUpdate }, handleSubmit: updateHandleSubmit, setValue } = useForm<any>();

    useEffect(() => {
        getBranches();
    }, []);

    const getBranches = () => {
        const param = {
            store_id: store?.store_id,
        }
        storeAPI.getStoreBranches(param, (msg: any, resp: any) => {
            if (resp?.data) {
                setBranches(resp.data);
            }
        }, (error: any, resp: any) => {
            console.log('error =>', error);
        })
    }

    const handleApplyFilter = (filterData: any) => {
        setFilterValue(filterData);
    };

    const handleClearFilter = () => {
        setFilterValue(null);
    };

    const handleIconClick = () => {
        setIsDivVisible(!isDivVisible);
    };

    const onClickEdit = (item: any, index: any) => {
        setValue("branchId", item?.branch_id);
        setValue("branchName", item?.branch_name);
        setValue("contactInfo", item?.contact_info);
        setValue("branchAddress", item?.address);
        setVisibleUpdateBnIndex(index)
    }

    const onSubmit = (data: any) => {
        setOnSubmitLoading(true);
        const param = {
            branch_name: data.branchName,
            address: data.branchAddress,
            contact_info: data.contactInfo,
        }
        console.log(param);

        try {
            setTimeout(() => {
                storeAPI.addStoreBranch(param, (msg: any, resp: any) => {
                    if (resp?.code === 201 || resp?.code === 200) {
                        toast.success(resp?.message);
                        // Refresh the local branch list
                        getBranches();
                        // Close the add branch form
                        setIsDivVisible(false);
                        // Dispatch action to refresh branches in Header navbar
                        dispatch({
                            type: ACTIONS.STORE.REFRESH_BRANCHES,
                            payload: Date.now(),
                        });
                    } else {
                        toast.error(resp?.message);
                    }
                    setOnSubmitLoading(false);
                }, (error: any, resp: any) => {
                    console.log('error =>', error, resp);
                    if (resp?.detail?.code === 400) {
                    } else {
                        toast.error("Something went wrong");
                    }
                    setOnSubmitLoading(false);
                });
            }, 3000)
        } catch (e) {
            // console.log('error =>', e);
            setOnSubmitLoading(false);
        }
    };

    const onUpdate = (data: any) => {
        setOnSubmitLoading(true);
        const param = {
            branch_id: data.branchId,
            branch_name: data.branchName,
            address: data.branchAddress,
            contact_info: data.contactInfo,
        }
        
        try {
            storeAPI.updateStoreBranchInfo(param, (msg: any, resp: any) => {
                if (resp?.code === 201 || resp?.code === 200) {
                    toast.success(resp?.message);
                    // Refresh the local branch list after successful update
                    getBranches();
                    // Close the update branch form
                    setIsDivUpdateVisible(false);
                    setVisibleUpdateBnIndex(-1);
                    // Dispatch action to refresh branches in Header navbar
                    dispatch({
                        type: ACTIONS.STORE.REFRESH_BRANCHES,
                        payload: Date.now(),
                    });
                } else {
                    toast.error(resp?.message);
                }
                setOnSubmitLoading(false);
            }, (error: any, resp: any) => {
                // console.log('error =>', error, resp);
                if (resp?.detail?.code === 400) {
                } else {
                    toast.error("Something went wrong");
                }
                setIsDivUpdateVisible(false);
                setOnSubmitLoading(false);
            });
        } catch (e) {
            // console.log('error =>', e);
            setIsDivUpdateVisible(false);
            setOnSubmitLoading(false);
        }
    };

    return (
        <>
            <div className="mt-6">
                <div className="flex justify-between items-center mb-4">
                    {isOnSubmitLoading && (
                        <div className="absolute inset-0 bg-gray-700 bg-opacity-50 flex justify-center items-center z-50">
                            <Spinner className="self-center z-50" />
                        </div>
                    )}
                    <h2 className="text-gray-500 text-xl font-semibold">Store Branch Information</h2>
                    <div className="relative flex space-x-2 items-center">

                        <Icon name="add" size="24" className={`bg-blue-500 hover:bg-blue-600 text-white text-sm p-3 rounded-full ${store?.branch_limit == branches?.length ? 'opacity-50 pointer-events-none' : ''}`} onClick={() => setIsDivVisible(!isDivVisible)} tooltipText="Add Branch" width='w-32' tooltipPosition='right' />
                    </div>
                </div>


                {isDivVisible && (
                    <div className="bg-gray-100 p-4 rounded-md mt-5">
                        <h3 className="text-gray-500 text-lg font-semibold">Add Branch</h3>
                        <form className="mt-4" onSubmit={handleSubmit(onSubmit)}>
                            <div className="mb-4 relative">
                                <input
                                    type="text"
                                    {...register("branchName", { required: true })}
                                    placeholder="Branch Name"
                                    className={`block-lg w-full rounded-sm bg-white px-3 py-1.5 pr-10 text-sm text-gray-500 outline outline-1 -outline-offset-1 ${errors.branchName ? 'outline-red-500 outline-2' : 'outline-gray-300'} placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm`}
                                />
                            </div>

                            <div className="mb-4 relative">
                                <input type="text"
                                    {...register("contactInfo", { required: true, minLength: 10, maxLength: 10 })}
                                    placeholder="Contact Info (10 digits)" inputMode="numeric" maxLength={10} onKeyDown={allowOnlyNumbers}
                                    className={`block-lg w-full rounded-sm bg-white px-3 py-1.5 pr-10 text-sm text-gray-500 outline outline-1 -outline-offset-1 ${errors.contactInfo ? 'outline-red-500 outline-2' : 'outline-gray-300'} placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm`}
                                />
                                {errors.contactInfo && (
                                    <span className="text-red-500 text-xs">Contact info must be exactly 10 digits</span>
                                )}
                            </div>
                            <div className="mb-4 relative">
                                <textarea
                                    rows={4}
                                    {...register("branchAddress", { required: true, minLength: 5 })}
                                    placeholder="Branch Address"
                                    className={`block-lg w-full rounded-sm bg-white px-3 py-3 pr-10 text-sm text-gray-500 outline outline-1 -outline-offset-1 ${errors.branchAddress ? 'outline-red-500 outline-2' : 'outline-gray-300'} focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm overflow-y-hidden`}
                                />
                            </div>

                            <div className="flex mb-3">
                                <button
                                    type="submit"
                                    className="flex w-32 justify-center rounded-md bg-blue-500 p-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500"
                                >
                                    Add
                                </button>
                                <button onClick={() => setIsDivVisible(!isDivVisible)}
                                    className="flex w-32 justify-center rounded-md bg-red-500 ml-2 p-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500"
                                >
                                    Close
                                </button>
                            </div>
                        </form>

                    </div>
                )}

                {branches.map((item: any, index: any) => {
                    return (
                        <>
                            <div key={index} className="bg-gray-100 p-2 rounded-md mt-5 flex justify-between items-center overflow-y-hidden">
                                <div className="text-sm text-gray-500">
                                    {item.branch_name}
                                </div>

                                <div className="text-sm text-gray-500">
                                    {item.address}
                                </div>

                                <div className="text-sm text-gray-500">
                                    {item.contact_info}
                                </div>

                                <div className="cursor-pointer text-blue-500 relative">
                                    <Icon name="edit" size="24" className="text-sm p-3" onClick={() => { setIsDivUpdateVisible(!isDivUpdateVisible); onClickEdit(item, index) }} />
                                </div>
                            </div>


                            {isDivUpdateVisible && visibleUpdateBrnIndex == index && (
                                <div className="bg-gray-100 p-4 rounded-md mt-5">
                                    <h3 className="text-gray-500 text-lg font-semibold">Update Branch</h3>
                                    <form className="mt-4" onSubmit={updateHandleSubmit(onUpdate)}>
                                        <div className="mb-4 relative">
                                            <input
                                                type="text"
                                                {...updateRegister("branchName", { required: true })}
                                                placeholder="Branch Name"
                                                className={`block-lg w-full rounded-sm bg-white px-3 py-1.5 pr-10 text-sm text-gray-500 outline outline-1 -outline-offset-1 ${errors.branchName ? 'outline-red-500 outline-2' : 'outline-gray-300'} placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm`}
                                            />
                                        </div>

                                        <div className="mb-4 relative">
                                            <input type="text"
                                                {...updateRegister("contactInfo", { required: true, minLength: 10, maxLength: 10 })}
                                                placeholder="Contact Info (10 digits)" inputMode="numeric" maxLength={10} onKeyDown={allowOnlyNumbers}
                                                className={`block-lg w-full rounded-sm bg-white px-3 py-1.5 pr-10 text-sm text-gray-500 outline outline-1 -outline-offset-1 ${errorsUpdate.contactInfo ? 'outline-red-500 outline-2' : 'outline-gray-300'} placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm`}
                                            />
                                            {errorsUpdate.contactInfo && (
                                                <span className="text-red-500 text-xs">Contact info must be exactly 10 digits</span>
                                            )}
                                        </div>
                                        <div className="mb-4 relative">
                                            <textarea
                                                rows={4}
                                                {...updateRegister("branchAddress", { required: true, minLength: 5 })}
                                                placeholder="Branch Address"
                                                className={`block-lg w-full rounded-sm bg-white px-3 py-3 pr-10 text-sm text-gray-500 outline outline-1 -outline-offset-1 ${errors.branchAddress ? 'outline-red-500 outline-2' : 'outline-gray-300'} focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm overflow-y-hidden`}
                                            />
                                        </div>

                                        <div className="flex mb-3">
                                            <button
                                                type="submit"
                                                className="flex w-32 justify-center rounded-md bg-blue-500 p-3 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500"
                                            >
                                                Update
                                            </button>
                                            <button onClick={() => setIsDivUpdateVisible(!isDivUpdateVisible)}
                                                className="flex w-32 justify-center rounded-md bg-red-500 ml-2 p-3 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500"
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </form>

                                </div>
                            )}
                        </>
                    );
                })}


                {/* {isDivUpdateVisible && (
                    <div className="bg-gray-100 p-4 rounded-md mt-5">
                        <h3 className="text-gray-500 text-lg font-semibold">Update Branch</h3>
                        <form className="mt-4" onSubmit={handleSubmit(onSubmit)}>
                            <div className="mb-4 relative">
                                <input
                                    type="text"
                                    {...register("branchName", { required: true })}
                                    placeholder="Branch Name"
                                    className={`block-lg w-full rounded-sm bg-white px-3 py-1.5 pr-10 text-sm text-gray-500 outline outline-1 -outline-offset-1 ${errors.branchName ? 'outline-red-500 outline-2' : 'outline-gray-300'} placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm`}
                                />
                            </div>

                            <div className="mb-4 relative">
                                <input type="text"
                                    {...register("contactInfo", { required: true, maxLength: 10 })}
                                    placeholder="Contact Info" inputMode="numeric" maxLength={10} onKeyDown={allowOnlyNumbers}
                                    className={`block-lg w-full rounded-sm bg-white px-3 py-1.5 pr-10 text-sm text-gray-500 outline outline-1 -outline-offset-1 ${errors.contactInfo ? 'outline-red-500 outline-2' : 'outline-gray-300'} placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm`}
                                />
                            </div>
                            <div className="mb-4 relative">
                                <textarea
                                    rows={4}
                                    {...register("branchAddress", { required: true, minLength: 5 })}
                                    placeholder="Branch Address"
                                    className={`block-lg w-full rounded-sm bg-white px-3 py-3 pr-10 text-sm text-gray-500 outline outline-1 -outline-offset-1 ${errors.branchAddress ? 'outline-red-500 outline-2' : 'outline-gray-300'} focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm overflow-y-hidden`}
                                />
                            </div>

                            <div className="flex mb-3">
                                <button
                                    type="submit"
                                    className="flex w-32 justify-center rounded-md bg-blue-500 p-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500"
                                >
                                    Update
                                </button>
                                <button onClick={() =>  setIsDivUpdateVisible(!isDivUpdateVisible)}
                                    className="flex w-32 justify-center rounded-md bg-red-500 ml-2 p-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500"
                                >
                                    Close
                                </button>
                            </div>
                        </form>

                    </div>
                )} */}
            </div>
        </>
    );
}

export default BranchInformation;